import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';

import { PortalApiService } from '../../portal-api.service';

// Shared page footer for the project sections (brand logo + project name, PM
// contact, and org email/phone). Reused by every project-section page; self-
// fetches from portal_project_footer given just the project id.
@Component({
	selector: 'portal-project-footer',
	templateUrl: './project-footer.component.html',
	styleUrls: ['./project-footer.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ProjectFooterComponent implements OnChanges {

	@Input() projectId!: string;

	project: any = null;
	contact: any = null;
	paymentDetails: any = null;

	constructor(private api: PortalApiService) {}

	ngOnChanges(): void {
		if (!this.projectId) return;
		this.api.project.footer(this.projectId, (res: any) => {
			this.project = res?.project || null;
			this.contact = res?.contact || null;
			this.paymentDetails = res?.payment_details || null;
		});
	}
}
